export enum SubmissionFormSteps {
  Inspect = 'inspect',
  Sign = 'sign'
}

export type FieldState<T> = {
  value: T;
  isError: boolean;
}
